var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 292.3 564.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.15,0C65.43,0,0,68.93,0,153.96c0,15.44,2.16,30.35,6.18,44.42,.89,3.12,1.87,6.19,2.94,9.22l11.94,26.02,116.37,253.53c3.42,7.45,14.02,7.45,17.44,0l116.37-253.53,11.94-26.02c1.07-3.03,2.05-6.1,2.94-9.22,4.02-14.07,6.18-28.98,6.18-44.42C292.3,68.93,226.87,0,146.15,0Zm0,224.18c-43.15,0-78.13-34.98-78.13-78.13s34.98-78.13,78.13-78.13,78.13,34.98,78.13,78.13-34.98,78.13-78.13,78.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.7,519.84c0,24.53-54.87,44.42-122.55,44.42s-122.55-19.89-122.55-44.42c0-20.84,39.58-38.33,92.97-43.12l19.17,41.03c4.08,8.74,16.74,8.74,20.82,0l19.17-41.03c53.39,4.79,92.97,22.28,92.97,43.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGisIcon);
export default __webpack_public_path__ + "static/media/gis-icon.fce77dcd285721c6366c1db39831790d.svg";
export { ForwardRef as ReactComponent };